import styled, { CSSProperties } from 'styled-components';

type Props = {
  appearance?: 'blue' | 'green' | 'grey';
};

const Title = styled.h3<Props>`
  margin: 0;
  padding: ${({ theme }) => theme.spaces.xl};
  color: ${({ theme }) => theme.fontColors.white};
  text-align: center;
  border-radius: ${({ theme }) => `${theme.radii.l} ${theme.radii.l}`} 0 0;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l};
  padding: ${({ theme }) => theme.spaces.xl};
  border-radius: 0 0 ${({ theme }) => `${theme.radii.l} ${theme.radii.l}`};
`;

const Root = styled.div<Props>`
  background: ${({ theme }) => theme.backgroundColors.default};
  border-radius: ${({ theme }) => theme.radii.l};
  box-shadow: ${({ theme }) => theme.boxShadow.base};
  height: 100%;

  ${Title} {
    background: ${({ theme, appearance }) =>
      appearance == 'blue'
        ? theme.backgroundColors.primary
        : appearance == 'green'
        ? theme.backgroundColors.green
        : theme.backgroundColors.lightgrey};
  }
`;

export const Compare = Object.assign(Root, { Title, Contents });
